import React from 'react';
import PropTypes from 'prop-types';
import { Button, FlexGrid, Header, Text } from '@gasbuddy/react-components';
import SupportLink from '../../components/SupportLink';
import Panel from '../../components/Panel';
import Container from '../../components/Container';

export default function SwitchIneligible({ consumerHost }) {
  return (
    <Container sidebar={false}>
      <Panel>
        <Header as="h2">Oops!</Header>
        <Text as="p" elongated size="lg" uppercase>
          We are unable to process this request.
        </Text>
        <Text as="p">Either a new card has already been ordered for this account or the account is not eligible to order a new card just yet.</Text>
        <br />
        <br />
        <FlexGrid>
          <FlexGrid.Column tablet={6} desktop={3}>
            <Button
              as="a"
              href={`//${consumerHost}/account/savings`}
              primary
              fluid
            >
              Back to Savings
            </Button>
          </FlexGrid.Column>
          <FlexGrid.Column tablet={6} desktopOffset={1} desktop={3}>
            <SupportLink uppercase>Contact Support</SupportLink>
          </FlexGrid.Column>
        </FlexGrid>
      </Panel>
    </Container>
  );
}

SwitchIneligible.propTypes = {
  consumerHost: PropTypes.string,
};

SwitchIneligible.defaultProps = {
  consumerHost: 'www.gasbuddy.com',
};
